// The ONLY place currency formatting + dir="ltr" live. Use this everywhere a
// number is rendered. Never inline toLocaleString() in JSX — the minus sign
// will land on the wrong side of the digits in RTL flow.
//
// See docs/platform/05-arbox-ui-design-system.md §2 + §15.

const CURRENCY_SYMBOLS: Record<string, string> = {
  ILS: '₪',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

function symbol(code?: string | null): string {
  if (!code) return '₪';
  return CURRENCY_SYMBOLS[code] ?? code;
}

function format(amount: number, code?: string | null): string {
  const sym = symbol(code);
  if (amount < 0) return `${sym}-${Math.abs(amount).toLocaleString()}`;
  return `${sym}${amount.toLocaleString()}`;
}

export interface MoneyProps {
  amount: number | null | undefined;
  currency?: string | null;
  className?: string;
  /** Render a dash for nullish amounts; otherwise return ''. */
  emptyDash?: boolean;
}

export function Money({ amount, currency = 'ILS', className, emptyDash = true }: MoneyProps) {
  if (amount == null) {
    return emptyDash ? <span className={className}>—</span> : null;
  }
  return (
    <span dir="ltr" className={className}>
      {format(Number(amount), currency)}
    </span>
  );
}
